<template>
  <ProjectOverView
    :on_site_width="on_site_width"
    padding="0 10px 10px 10px"
  >
    <!-- ??? -->
    <template #new-project-dialog>
      <DialogNewProject
        v-if="get_dialog_new_project_show"
        style="position: fixed"
      />
    </template>

    <!-- HEADER -->
    <template #action_bar>
      <div class="projectsoverviewonsite-header">
        <div class="projectsoverviewonsite-search-bar">
          <SearchBar
            :is_live_emit="true"
            max_width="600"
            @search="updateOverviewFilter($event)"
          />
        </div>
        <DropDown
          :items="sort_options.map(item => item.name)"
          :value="project_overview_sort.name"
          max_width="200"
          @selected="updateOverviewSorting($event)"
        />
      </div>
    </template>

    <!-- ACTUAL CARD -->
    <template v-if="!loading" #projects>
      <!-- ??? -->
      <router-view height="100%"/>

      <!-- UPPER HALF -->
      <ProjectCardOnSite
        v-for="project in getProjectOverview('projects').sort(sortFn)"
        :key="project.type + project.id"
        :header="project.name"
        :image="project.image"
        :role="project.prole"
        :status="project.status"
        :loading="project.id === project_id_loading ? true : false"
        pointer
        @clickAll="routeToProject(project.id, project.information.trains_count)"
      >
        <template #body>
          <!-- BOTTOM HALF -->
          <div
            v-if="project.work_packages.length"
            class="projectsoverviewonsite-info-wps"
          >
            <!-- SHOWS WP TYPES -->
            <WorkPackage
              v-for="(work_package, index) in getWorkpackageArray(project)"
              style="flex-shrink: 0;"
              :key="index"
              :color="`${work_package.color} ${work_package.color.includes('lighten') || work_package.color.includes('darken')? '':'lighten-1'}`"
              :token="work_package.token"
              :icon="work_package.icon"
              :zoom="1"
            >
              <!-- SHOWS AMOUNT OF WP -->
              <template #workpackage>
                <StandardBadge
                  color="white"
                  :text="work_package.count"
                  content_color="black"
                  :zoom="1"
                />
              </template>
            </WorkPackage>

            <!-- MORE DISPLAY FOR MISSING WPS -->
            <div
              v-if="getNeedsMorePlaceholder(project.work_packages.length)"
              class="projectsoverviewonsite-more-wp"
              :style="`border-color: ${getTranspHexColor(getColor('primary'), 0.2)};`"
            >
              <!-- SHOWS MISSING WP TYPES -->
              <TText
                :text="`+${project.work_packages.length - wp_space_count + 1}`"
                :color="getTranspHexColor(getColor('primary'), 0.2)"
                font_weight="500"
              />
              <!-- SHOWS AMOUNT OF MISSING WPS -->
              <StandardBadge
                color="white"
                :text="getMissingWorkPackageCount(project.work_packages)"
                content_color="black"
                :zoom="1"
              />
            </div>
          </div>
        </template>
      </ProjectCardOnSite>
    </template>
  </ProjectOverView>
</template>
<script>
import { ProjectOverviewMixin } from '@/mixins/ProjectOverview.mixin.js';
import { TColor } from '@/mixins/TColor.mixin.js';
import { mapActions, mapGetters, } from 'vuex';

import SearchBar from '@/components/WorkPackageWIP/SearchBar.component.vue';
import DropDown from '@/components/WorkPackageWIP/DropDown.component.vue';
import DialogNewProject from '@/components/ProjectOverView/DialogNewProject.component.vue';
import ProjectOverView from '@/components/ProjectOverView/ProjectOverView.component.vue';
import store from '@/store/index'
import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue';
import ProjectCardOnSite from '@/components/ProjectOverView/ProjectCardOnSite.component.vue';

export default {
  name: 'App',

  components: {
    DialogNewProject,
    ProjectOverView,
    WorkPackage,
    StandardBadge,
    ProjectCardOnSite,
    SearchBar,
    DropDown,
  },

  mixins: [
    ProjectOverviewMixin,
    TColor,
  ],

  data: () => ({
    project_id_loading: -1,
    loading: true,
    tserachupdatekey: 0,
    search: '',
    sortFn: undefined,
    on_site_width: 335,
    sort_options: [
      {value: 'created_asc', name: 'Created date (asc)'},
      {value: 'created_desc', name: 'Created date (desc)'},
      {value: 'status_asc', name: 'Project status (asc)'},
      {value: 'status_desc', name: 'Project status (desc)'},
      {value: 'name_asc', name: 'Name alphabetical (a-z)'},
      {value: 'name_desc', name: 'Name alphabetical (z-a)'}
    ],
    project_overview_sort: {
      value: 'status_asc',
      name: 'Project status (asc)'
    },
  }),

  created() {
    let sort_fun = localStorage.getItem('TAKT_projectsoverview_sort') || 'status_asc';
    // Hacky fix: should not be requried after a while...
    if (sort_fun === 'undefined' || sort_fun === '[object Object]') {
      sort_fun = 'status_asc';
    }
    this.selectSortFunction(sort_fun);
    this.project_overview_sort = this.sort_options.find( item => item.value === sort_fun);

    let promisses = [];
    promisses.push(
      store.dispatch('Ultra/requestUObject', {
        url: [
          {projects: ''},
          {showWithEntitiesNormalized: ''}
        ]
      })
    );

    Promise.all(promisses).then(() => {
      this.loading = false;
      this.setLoadingProjectOverview(false);
    });
  },

  watch: {
    project_overview_sort: {
      handler(newVal){
        if (newVal.value) {
          this.selectSortFunction(newVal.value);
        } else {
          this.selectSortFunction(newVal);
        }
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters('Project', [
      'getProjectOverview',
    ]),
    ...mapGetters('ProjectCalendar', [
      'getCurrentTaktIndex',
    ]),
    ...mapGetters('View', [
      'get_dialog_new_project_show'
    ]),

    wp_space_count() {
      let divisions = Math.floor(screen.width / this.on_site_width);
      if(divisions > 1) {
        if(divisions * this.on_site_width + 2 * 10 + (divisions - 1) * 10 > screen.width) {
          divisions--;
        }
      }
      // screenwidth - container padding - right side padding per division - image width per division - gridgap between two divisions / divisions
      let avaiable_space = (screen.width - (2 * 10) - (divisions * 2 * 8) - (divisions * 80) - (10 * (divisions - 1))) / divisions;
      let ret = Math.floor(avaiable_space / (54 + 2 * 2)); // wp width (54) + 2 * margin (2)
      return ret;
    }
  },

  methods: {
    ...mapActions('Project', [
      'updateOverviewFilter',
    ]),

    ...mapActions('View', [
      'setLoadingProjectOverview',
    ]),

    getWorkpackageArray(project) {
      let arr = project.work_packages;
      if(this.getNeedsMorePlaceholder(arr.length))
        { return arr.slice(0, this.wp_space_count - 1); }
      else
        { return arr; }
    },

    getNeedsMorePlaceholder(wp_count) {
      return wp_count > this.wp_space_count - 1 && wp_count != this.wp_space_count;
    },

    getMissingWorkPackageCount(work_packages) {
      let count = 0;
      for(let i = this.wp_space_count - 1; i < work_packages.length; i++) {
        count += work_packages[i].count;
      }
      return count;
    },

    selectSortFunction(newVal){
      localStorage.setItem('TAKT_projectsoverviewonsite_sort', newVal);
      switch (newVal) {
        case 'created_asc':
          this.sortFn = this.createdAscSort;
          break;
        case 'created_desc':
          this.sortFn = this.createdDescSort;
          break;
        case 'status_asc':
          this.sortFn = this.statusAscSort;
          break;
        case 'status_desc':
          this.sortFn = this.statusDescSort;
          break;
        case 'name_asc':
          this.sortFn = this.nameAscSort;
          break;
        case 'name_desc':
          this.sortFn = this.nameDescSort;
          break;
        default:
          this.sortFn = this.createdAscSort;
      }
    },

    createdAscSort(a,b) {
      if (a.id < b.id) {
        return -1;
      }
      if (a.id > b.id) {
        return 1;
      }
      return 0;
    },

    createdDescSort(a,b) {
      if (a.id > b.id) {
        return -1;
      }
      if (a.id < b.id) {
        return 1;
      }
      return 0;
    },

    statusAscSort(a,b) {
      return a.status.localeCompare(b.status);
    },

    statusDescSort(a,b) {
      return b.status.localeCompare(a.status);
    },

    nameAscSort(a,b) {
      return a.name.localeCompare(b.name);
    },

    nameDescSort(a,b) {
      return b.name.localeCompare(a.name);
    },

    updateOverviewSorting(sort_by) {
      let option = this.sort_options.filter(elem => { return elem.name === sort_by })[0];
      this.project_overview_sort = option;
    },

    routeToProject(project_id, trains_count) {
      this.project_id_loading = project_id;
      // if (this.$vuetify.breakpoint.smAndDown) {
      if (store.getters['View/isMobile'] || store.getters['View/getUseOnSite']) {
        store.dispatch('Ultra/requestUObject', {
          url: [
            {projects: project_id},
            {'showWithEntitiesNormalized': ''}
          ]
        }).then(() => {
            let promises = [
              store.dispatch('Project/requestProjectPermissions', {
                project_id: project_id
              }),
              store.dispatch('Message/requestMessagesProjectActive', {
                project_id: project_id
              }),
              store.dispatch('Project/requestProjectInformation', {
                project_id: project_id
              }),
            ];
            Promise.all(promises)
            .then(() => {
              this.$router.push({
                name: 'ProjectWallet',
                params: {
                  project_id: project_id,
                  takt_index: this.getCurrentTaktIndex(project_id) !== false?
                  Math.abs(this.getCurrentTaktIndex(project_id)):1
                }
              });
            });
        });
      } else {
        if (trains_count > 0) {
          this.$router.push({name: 'Project', params: {project_id: project_id}});
        } else {
          this.$router.push({name: 'AddTrain',
          params: {
            project_id: project_id,
            train_index: 0,
            direction: 0
          }});
        }
      }
    },
  }
};
</script>

<style>
.projectsoverviewonsite-header {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  padding: 16px 8px;
  padding-bottom: 10px;
  grid-gap: 16px;
}
.projectsoverviewonsite-search-bar {
  display: flex;
  width: 100%;
  justify-content: center;
}
.projectsoverviewonsite-info-wps {
  flex-grow: 1;
  display: flex;
  height: 100%;
  flex-wrap: wrap;
}
.projectsoverviewonsite-more-wp {
  width: var(--workpackage_width);
  height: var(--workpackage_height);
  border: 1px solid;
  margin: 2px;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
</style>
